import React from 'react';
import { useNavigate } from 'react-router-dom';
import './SportMentalTestsScreen.css';

export default function TestSummary() {
  const navigate = useNavigate();

  return (
    <div style={{
      minHeight: '100vh',
      background: `linear-gradient(to top left, #2AA7A1 -25.98%, #E0F7F4 66.42%)`,
      fontFamily: 'Poppins, sans-serif',
    }}>
      {/* Dashboard Navbar */}
      {/* <header className="dashboard-header" style={{position: 'static'}}>
        <div className="header-content">
          <h1 className="header-logo">Power Mind Metrics</h1>
          <nav className="header-nav">
            <button className="nav-link" onClick={() => navigate('/profile')}>Profile</button>
            <button className="nav-link" onClick={() => navigate('/logout')}>Logout</button>
          </nav>
        </div>
      </header> */}
      {/* Main Card */}
      <div style={{
        paddingTop: 50,
        minHeight: 'calc(100vh - 64px)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        // marginTop: 64,
      }}>
        <div style={{
          background: '#fff',
          borderRadius: 16,
          boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
          width: window.innerWidth > 600 ? 1028 : '100%',
          maxWidth: window.innerWidth > 600 ? undefined : '98vw',
          height: window.innerWidth > 600 ? 600 : 'auto',
          padding: window.innerWidth > 600 ? 36 : '1.2rem 0.7rem 1.5rem 0.7rem',
          gap: 36,
          opacity: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          boxSizing: 'border-box',
          margin: 0,
          marginBottom: window.innerWidth > 600 ? 0 : '80px',
        }}>
          <h1 style={{fontWeight: 700, fontSize: 36, color: '#2AA7A1', marginBottom: 16, textAlign: 'center', letterSpacing: 1}}>Test Submission Complete!</h1>
          <p style={{fontSize: 20, color: '#444', marginBottom: 24, textAlign: 'center', fontWeight: 500}}>
            Thank you for completing the assessment.<br/>Your responses have been successfully recorded.
          </p>
          <div style={{
            background: '#e0f7f4',
            borderRadius: 12,
            padding: 28,
            marginBottom: 32,
            width: '100%',
            maxWidth: 600,
            boxShadow: '0 2px 8px rgba(42,167,161,0.07)',
          }}>
            <p style={{fontWeight: 600, color: '#2AA7A1', fontSize: 18, marginBottom: 12}}>What's next?</p>
            <ul style={{fontSize: 16, color: '#444', lineHeight: 1.7, margin: 0, paddingLeft: 24}}>
              <li>Your test results will be analyzed</li>
              {/* <li>You can view your results in your dashboard</li> */}
              <li>Consider taking other assessments to get a complete picture of your mental fitness</li>
            </ul>
          </div>
          <button 
            className="start-test-button"
            onClick={() => navigate('/dashboard')}
            style={{ marginTop: 10, width: 320, height: 48, fontSize: 18, borderRadius: 8, background: '#2AA7A1', color: '#fff', fontWeight: 600, fontFamily: 'Poppins, sans-serif', border: 'none', letterSpacing: 1, boxShadow: '0 2px 8px rgba(42,167,161,0.07)' }}
          >
            Return to Dashboard
          </button>
        </div>
      </div>
      
      {/* Footer */}
      <div style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        background: 'rgba(255, 255, 255, 0.95)',
        backdropFilter: 'blur(10px)',
        borderTop: '1px solid rgba(0, 0, 0, 0.1)',
        padding: '12px 0',
        textAlign: 'center',
        fontFamily: 'Poppins, sans-serif',
        zIndex: 100
      }}>
        <p style={{
          margin: 0,
          fontSize: '14px',
          color: 'rgba(75, 75, 75, 0.8)',
          fontWeight: 400
        }}>
          © 2025 All rights reserved Power Mind Metrics
        </p>
      </div>
    </div>
  );
} 